/* Shared page behaviour for the lean templates (layout/theme.liquid `ao_lean`: the rebuilt
   product pages), which load no jQuery. These are the parts of assets/scripts.js that do
   something on those pages; its other handlers target markup they don't have. Plain JS.
   - the header's cart icon opens the cart drawer (sections/slide-rings-cart); its close
     button, "Continue Shopping" and the dimmed page behind it close it;
   - body.sticky once the page has scrolled 40px (style.css moves the drawer up under the
     header with `.sticky .side-cart`). */
(function () {
  'use strict';

  var body = document.body;

  // The drawers hide the Gorgias chat launcher and the Postscript pill while they're open
  function widgets() {
    return [document.getElementById('chat-button'), document.getElementById('ps__widget_container')];
  }
  function showWidgets() {
    widgets().forEach(function (el) {
      if (el) el.classList.remove('hidden');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('.cart-i')) {
      body.classList.toggle('cart-open');
      var w = widgets();
      if (w[0]) w[0].classList.add('hidden');
      if (w[1] && window.innerWidth < 992) w[1].classList.add('hidden');
      return;
    }

    if (t.closest('.clos')) {
      body.classList.remove('cart-open');
      showWidgets();
      return;
    }

    if (t.closest('.page-overlay')) {
      body.classList.remove('menu-open', 'no-scroll', 'cart-open', 'filters-open');
      document.querySelectorAll('.desk-search_wrap.active, .collection-sidebar.active, .chain_slideout_container.active').forEach(function (el) {
        el.classList.remove('active');
      });
      showWidgets();
    }
  });

  // Written only when it changes: this runs on every scroll frame
  var sticky = null;
  function syncSticky() {
    var on = (window.pageYOffset || document.documentElement.scrollTop) > 40;
    if (on === sticky) return;
    sticky = on;
    body.classList.toggle('sticky', on);
  }
  window.addEventListener('scroll', syncSticky, { passive: true });
  syncSticky();
})();
